import { OnboardingStep } from '../../types/onboarding';

// Determine next step based on current step and state
const getNextStep = (
  currentStep: OnboardingStep,
  flowSteps: OnboardingStep[],
): OnboardingStep | null => {
  const currentIndex = flowSteps.indexOf(currentStep);
  if (currentIndex < flowSteps.length - 1) {
    return flowSteps[currentIndex + 1];
  }

  return null;
};

export default getNextStep;
